import styles from './Column.module.scss'

export default function Column({ type, children }) {
  let classes = {}
  switch (type) {
    case '40':
      classes = styles.fourty
      break
    case '60':
      classes = styles.sixty
      break
    default:
      classes = styles.default
      break
  }

  return <section className={classes}>{children}</section>
}
